// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selector
import { isUpdateAvailableSelector } from '../../../../../reducers/version/versionSelector';

// Actions
import { showTooltip } from '../../../../../components/tooltips/tooltipActions';

// Styles
import './PwaUpdateNotify.scss';

const mapStateToProps = createStructuredSelector({
    isUpdateAvailable: isUpdateAvailableSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchShowTooltip: (tooltip) => dispatch(showTooltip({ id: 'pwa-update', tooltip })),
});

const PwaUpdateNotify = (props) => {
    const { isUpdateAvailable, dispatchShowTooltip } = props;

    React.useEffect(() => {
        isUpdateAvailable &&
            dispatchShowTooltip({
                selector: '.AccountUtil',
                position: 'bottom',
                text: 'A new version of Milanote is ready to install',
            });
    }, [isUpdateAvailable]);

    if (!isUpdateAvailable) return null;

    return (
        <div className="PwaUpdateNotify">
            <div className="pulse" />
        </div>
    );
};

PwaUpdateNotify.propTypes = {
    dispatchShowTooltip: PropTypes.func,
    isUpdateAvailable: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(PwaUpdateNotify);
